export interface DispatchFileUpload {
  content: unknown;
  fileContentType: string;
  fileName: string;
  fileSize: number;
  employeeJobID: string;
}
